import React from 'react';
import { Favorite, Visibility } from '@mui/icons-material';
import { formatCount } from '../../utils/formatCount';
import './CreatorSummaryTile.css';

const TXT_LIKES = { fr: 'Likes', en: 'Likes', de: 'Likes', es: 'Likes', pt: 'Curtidas' };
const TXT_VIEWS = { fr: 'Vues', en: 'Views', de: 'Aufrufe', es: 'Visitas', pt: 'Visualizações' };
const TXT_STUFF_ONE = { fr: 'stuff', en: 'build', de: 'Build', es: 'build', pt: 'build' };
const TXT_STUFF_MANY = { fr: 'stuffs', en: 'builds', de: 'Builds', es: 'builds', pt: 'builds' };

const PLACEHOLDER_USER = 'username899';
const PLACEHOLDER_BUILDS = 14;

function stuffsLabel(count, lang) {
    const n = Math.max(0, Number(count) || 0);
    const word = n === 1
        ? (TXT_STUFF_ONE[lang] || TXT_STUFF_ONE.en)
        : (TXT_STUFF_MANY[lang] || TXT_STUFF_MANY.en);
    return `${n} ${word}`;
}

export function CreatorSummaryTileButton({ creator, lang, onSelect }) {
    if (!creator) {
        return (
            <button
                type="button"
                className="community-top-creator-tile community-top-creator-tile--placeholder"
                disabled
                tabIndex={-1}
                aria-hidden
            >
                <span className="community-top-creator-avatar-wrap">
                    <span className="community-top-creator-avatar community-top-creator-avatar--placeholder" />
                </span>
                <span className="community-top-creator-name community-top-creator-name--placeholder">{PLACEHOLDER_USER}</span>
                <span className="community-top-creator-builds community-top-creator-builds--placeholder">
                    {stuffsLabel(PLACEHOLDER_BUILDS, lang)}
                </span>
                <div className="community-top-creator-metrics">
                    <span className="community-top-creator-metric">
                        <Favorite fontSize="inherit" aria-hidden />
                        <span>899</span>
                    </span>
                    <span className="community-top-creator-metric">
                        <Visibility fontSize="inherit" aria-hidden />
                        <span>2899</span>
                    </span>
                </div>
            </button>
        );
    }
    const likes = formatCount(creator.total_likes ?? creator.metrics?.likes, lang);
    const views = formatCount(creator.total_views ?? creator.metrics?.views, lang);
    const builds = Number(creator.build_count ?? creator.metrics?.builds ?? 0);
    return (
        <button
            type="button"
            className="community-top-creator-tile"
            onClick={() => onSelect?.(creator)}
        >
            <span className="community-top-creator-avatar-wrap">
                {creator.avatar_url ? (
                    <img src={creator.avatar_url} alt="" className="community-top-creator-avatar" />
                ) : (
                    <span className="community-top-creator-avatar community-top-creator-avatar--empty" aria-hidden />
                )}
            </span>
            <span className="community-top-creator-name">{creator.display_name || creator.public_slug}</span>
            <span className="community-top-creator-builds">{stuffsLabel(builds, lang)}</span>
            <div className="community-top-creator-metrics">
                <span className="community-top-creator-metric" title={TXT_LIKES[lang] || TXT_LIKES.en}>
                    <Favorite fontSize="inherit" aria-hidden />
                    <span>{likes}</span>
                </span>
                <span className="community-top-creator-metric" title={TXT_VIEWS[lang] || TXT_VIEWS.en}>
                    <Visibility fontSize="inherit" aria-hidden />
                    <span>{views}</span>
                </span>
            </div>
        </button>
    );
}
